"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubArray = void 0;
function isSubArray(query, collection) {
    if (!(collection instanceof Array)) {
        return query === collection;
    }
    return query instanceof Array ? query.every((element) => collection.includes(element)) : collection.includes(query);
}
exports.isSubArray = isSubArray;
//# sourceMappingURL=is-sub-array.js.map